/**
 * Single source of truth for the Network Portfolio Management TanStack Query key prefixes.
 *
 * Every `npm-*` project cache key is built from one of these constants (via the factories in
 * {@link ./services/npmQueries}) so the prefixes can never drift between the queries that populate
 * the cache and the hooks that invalidate it. The values are the exact literal strings already in
 * use — this is a naming/centralization refactor, not a cache-identity change.
 *
 * `npm-saved-views` is deliberately absent: it already has its own factory in
 * `utils/savedViewsUtils.ts` and is out of scope for the project-list identity set.
 */
export const NPM_QUERY_KEYS = {
  filterOptions: "npm-filter-options",
  gapByCountyStatus: "npm-gap-by-county-status",
  gapsWidget: "npm-gaps-widget",
  projectGroups: "npm-project-groups",
  projectIds: "npm-project-ids",
  projects: "npm-projects",
  sortedProjectIds: "npm-sorted-project-ids",
} as const;
